var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from "react";
import { Button, Checkbox, Dimmer, Divider, Form, Grid, Header, Icon, Input, List, Loader, Select, } from "semantic-ui-react";
import * as zxcvbn from "zxcvbn";
import { ORIGIN } from "../Config";
import * as countries from "../countries.json";
import ErrorDisplay from "../ErrorDisplay";
import BaseFieldWithErrorDisplay from "../FieldWithErrorDisplay";
import ffpeHumanPancreasImg from "../images/hcr-ffpe-human-pancreas.jpg";
import hcrRnaFishImg from "../images/HCR-RNA-FISH-01.png";
import { debounce } from "../kit/automated-pro/EditKitForm";
import { postJsonWithAuthn } from "../RequestHelpers";
import * as usStates from "../us-states.json";
import { addressCandidateDescription, addressCandidateStreetLine, lookupAddress, } from "./AddressLookup";
import { browserLocaleCountryCode, categoryForRorTypes, formatPhoneNumberInput, phoneInfoFor, rorDescription, searchOrganizations as searchRorOrganizations, } from "./OrganizationLookup";
var REGISTER_ENDPOINT = "/user/register";
var VALIDATE_ENDPOINT = "/user/register/validate";
var EMAIL_VERIFICATION_STEP = 5;
var PRIVACY_POLICY_URL = ORIGIN === "hcr"
    ? "https://www.hcrimaging.com/legal/privacy-policy"
    : "https://www.molecularinstruments.com/privacy-policy";
var TERMS_URL = ORIGIN === "hcr"
    ? "https://www.hcrimaging.com/legal/terms"
    : "https://www.molecularinstruments.com/terms";
var ACCOUNT_DETAILS_PANEL = ORIGIN === "hcr"
    ? {
        image: ffpeHumanPancreasImg,
        alt: "FFPE human pancreas imaged with HCR",
        title: "FFPE Human Pancreas",
        subtitle: undefined,
    }
    : {
        image: hcrRnaFishImg,
        alt: "HCR RNA-FISH imaging",
        title: "Whole-mount chicken embryo",
        subtitle: "Gallus gallus domesticus",
    };
var FieldWithErrorDisplay = function (props) {
    return React.createElement(BaseFieldWithErrorDisplay, __assign({}, props, { inlineErrors: true }));
};
var MIN_PASSWORD_LENGTH = 8;
var MIN_PASSWORD_SCORE = 2;
var PASSWORD_STRENGTH_LABELS = {
    0: "Very weak",
    1: "Weak",
    2: "Fair",
    3: "Good",
    4: "Strong",
};
var PASSWORD_STRENGTH_TIPS = [
    "Use at least 8 characters.",
    "Combine uppercase letters, lowercase letters, numbers, and symbols.",
    "Avoid repeated or sequential characters like aaaa, 1234, or abcd.",
];
var STEP_TITLES = [
    "Account details",
    "Lab & shipping",
    "Billing details",
    "Terms & privacy",
    "Verify email",
];
var ORGANIZATION_TYPE_OPTIONS = [
    { text: "University", value: "UNIVERSITY" },
    { text: "Government Lab", value: "GOVT_LAB" },
    { text: "Nonprofit Research Institute", value: "NONPROFIT_INST" },
    { text: "Research Hospital", value: "RESEARCH_HOSPITAL" },
    { text: "Company", value: "COMPANY" },
];
var COURIER_ACCOUNT_OPTIONS = [
    { text: "No courier account", value: "NONE" },
    { text: "FedEx account", value: "FEDEX" },
    { text: "DHL account", value: "DHL" },
];
var COUNTRY_OPTIONS = countries
    .map(function (c) { return ({ value: c.value, text: c.text }); });
var US_STATE_OPTIONS = usStates
    .map(function (s) { return ({ value: s.value, text: s.text }); });
var EMPTY_ADDRESS = {
    street: "",
    streetLine2: "",
    city: "",
    stateProvince: "",
    zipPostalCode: "",
    countryCode: "",
};
var normalizeShippingLabelText = function (value) {
    return value.trim().replace(/\s+/g, " ");
};
var NewRegistrationPage = /** @class */ (function (_super) {
    __extends(NewRegistrationPage, _super);
    function NewRegistrationPage(props) {
        var _this = _super.call(this, props) || this;
        _this.debouncedOrganizationSearch = debounce(function (_, query) {
            _this.runOrganizationSearch(query);
        }, 300);
        _this.addressSearchSequence = 0;
        _this.debouncedAddressSearch = debounce(function (_, query) {
            _this.runAddressSearch(query);
        }, 300);
        _this.billingAddressSearchSequence = 0;
        _this.debouncedBillingAddressSearch = debounce(function (_, query) {
            _this.runBillingAddressSearch(query);
        }, 300);
        _this.renderStepIndicator = function () {
            return React.createElement("div", { className: "new-registration-steps" }, STEP_TITLES.map(function (title, i) {
                var stepNumber = i + 1;
                var stepState;
                if (stepNumber < _this.state.step) {
                    stepState = "completed";
                }
                else if (stepNumber === _this.state.step) {
                    stepState = "active";
                }
                else {
                    stepState = "upcoming";
                }
                var stepContent = React.createElement(React.Fragment, null,
                    React.createElement("span", { className: "new-registration-step-marker" }, stepState === "completed" ? React.createElement(Icon, { name: "check" }) : stepNumber),
                    React.createElement("span", { className: "new-registration-step-label" }, title));
                if (stepState === "completed" && !_this.state.accountCreated) {
                    return React.createElement("button", { key: title, type: "button", className: "new-registration-step " + stepState + " clickable", onClick: _this.onStepIndicatorClick(stepNumber), "aria-label": "Go back to " + title }, stepContent);
                }
                return React.createElement("div", { key: title, className: "new-registration-step " + stepState }, stepContent);
            }));
        };
        _this.renderEmailVerificationStep = function () {
            return React.createElement("div", { className: "verify-email-step" },
                React.createElement("div", { className: "verify-email-icon" },
                    React.createElement(Icon, { name: "mail" })),
                React.createElement(Header, { as: "h4", className: "new-registration-section-title verify-email-title" }, "Verify your email to continue"),
                React.createElement("p", { className: "verify-email-description" }, "We sent a verification link to your email address. After you verify your email, you can request your complimentary Starter Kit from the verification page."),
                React.createElement("div", { className: "verify-email-chip" }, _this.state.email));
        };
        _this.renderStepBody = function () {
            switch (_this.state.step) {
                case 1:
                    return _this.renderAccountDetailsStep();
                case 2:
                    return _this.renderLabShippingStep();
                case 3:
                    return _this.renderBillingDetailsStep();
                case 4:
                    return _this.renderTermsPrivacyStep();
                default:
                    return _this.renderEmailVerificationStep();
            }
        };
        _this.renderActions = function () {
            switch (_this.state.step) {
                case 1:
                    return React.createElement("div", { className: "new-registration-actions" },
                        React.createElement("span", null),
                        React.createElement(Button, { positive: true, content: "Continue", loading: _this.state.loading, disabled: _this.state.loading
                                || (_this.state.password.length > 0 && !_this.passwordMeetsRequirements()), onClick: _this.onContinueFromStep(1) }));
                case 2:
                    return React.createElement("div", { className: "new-registration-actions" },
                        React.createElement(Button, { basic: true, content: "Back", icon: "arrow left", disabled: _this.state.loading, onClick: _this.onBack }),
                        React.createElement(Button, { positive: true, content: "Continue", loading: _this.state.loading, disabled: _this.state.loading, onClick: _this.onContinueFromStep(2) }));
                case 3:
                    return React.createElement("div", { className: "new-registration-actions" },
                        React.createElement(Button, { basic: true, content: "Back", icon: "arrow left", disabled: _this.state.loading, onClick: _this.onBack }),
                        React.createElement(Button, { positive: true, content: "Continue", loading: _this.state.loading, disabled: _this.state.loading, onClick: _this.onContinueFromStep(3) }));
                case 4:
                    return React.createElement("div", { className: "new-registration-actions" },
                        React.createElement(Button, { content: "Back", disabled: _this.state.loading, onClick: _this.onBack }),
                        React.createElement(Button, { positive: true, content: "Create account", loading: _this.state.loading, disabled: _this.state.loading, onClick: _this.onSubmitRegistration }));
                case EMAIL_VERIFICATION_STEP:
                    return null;
                default:
                    return null;
            }
        };
        _this.renderAccountDetailsStep = function () {
            return React.createElement(Form, { error: _this.state.errors.length > 0 },
                React.createElement("div", { className: "account-details-layout" },
                    React.createElement("div", { className: "account-details-fields" },
                        React.createElement(Grid, { columns: 2, stackable: true },
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, null,
                                    React.createElement(FieldWithErrorDisplay, { errors: _this.state.errors, errorPath: "/firstName", labelContent: "First name", required: true },
                                        React.createElement(Input, { placeholder: "Linus", value: _this.state.firstName, onChange: _this.onFieldChange("firstName") }))),
                                React.createElement(Grid.Column, null,
                                    React.createElement(FieldWithErrorDisplay, { errors: _this.state.errors, errorPath: "/lastName", labelContent: "Last name", required: true },
                                        React.createElement(Input, { placeholder: "Pauling", value: _this.state.lastName, onChange: _this.onFieldChange("lastName") })))),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: 16 },
                                    React.createElement(FieldWithErrorDisplay, { errors: _this.state.errors, errorPath: "/email", labelContent: "Email", required: true },
                                        React.createElement(Input, { type: "email", placeholder: "lpauling@caltech.example", value: _this.state.email, onChange: _this.onFieldChange("email") })))),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: 16 },
                                    React.createElement(FieldWithErrorDisplay, { errors: _this.state.errors, errorPath: "/password", labelContent: "Password", required: true },
                                        React.createElement(Input, { type: _this.state.showPassword ? "text" : "password", value: _this.state.password, onChange: _this.onPasswordChange, icon: React.createElement(Icon, { name: _this.state.showPassword ? "eye slash" : "eye", link: true, onClick: _this.toggleShowPassword }) }),
                                        _this.renderPasswordStrengthMeter()))),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: 16 },
                                    React.createElement(FieldWithErrorDisplay, { errors: _this.state.errors, errorPath: "/confirmPassword", labelContent: "Confirm password", required: true },
                                        React.createElement(Input, { type: _this.state.showConfirmPassword ? "text" : "password", value: _this.state.confirmPassword, onChange: _this.onFieldChange("confirmPassword"), icon: React.createElement(Icon, { name: _this.state.showConfirmPassword ? "eye slash" : "eye", link: true, onClick: _this.toggleShowConfirmPassword }) })))))),
                    React.createElement("div", { className: "account-details-panel" },
                        React.createElement("img", { src: ACCOUNT_DETAILS_PANEL.image, alt: ACCOUNT_DETAILS_PANEL.alt }),
                        React.createElement("div", { className: "account-details-panel-caption" },
                            React.createElement("span", { className: "account-details-panel-caption-title" }, ACCOUNT_DETAILS_PANEL.title),
                            ACCOUNT_DETAILS_PANEL.subtitle !== undefined &&
                                React.createElement("span", { className: "account-details-panel-caption-subtitle" }, ACCOUNT_DETAILS_PANEL.subtitle)))),
                React.createElement(ErrorDisplay, { errors: _this.state.errors, errorPath: "/" }));
        };
        _this.passwordMeetsRequirements = function () {
            return _this.state.password.length >= MIN_PASSWORD_LENGTH && _this.state.passwordScore >= MIN_PASSWORD_SCORE;
        };
        _this.renderPasswordStrengthMeter = function () {
            if (_this.state.password === "") {
                return null;
            }
            return React.createElement("div", { className: "password-strength-meter" },
                React.createElement("div", { className: "password-strength-track" },
                    React.createElement("div", { className: "password-strength-fill strength-" + _this.state.passwordScore, style: { width: (_this.state.passwordScore + 1) * 20 + "%" } })),
                React.createElement("span", { className: "password-strength-label" }, PASSWORD_STRENGTH_LABELS[_this.state.passwordScore]),
                !_this.passwordMeetsRequirements() &&
                    React.createElement("ul", { className: "password-strength-feedback" }, PASSWORD_STRENGTH_TIPS.map(function (tip, i) { return React.createElement("li", { key: i }, tip); })));
        };
        _this.renderLabShippingStep = function () {
            var isUs = _this.state.shippingAddress.countryCode === "US";
            var courierAccountLabel = _this.courierAccountNumberLabel();
            return React.createElement(Form, { error: _this.state.errors.length > 0 },
                React.createElement(Header, { as: "h4", className: "new-registration-section-title" }, "Organization"),
                React.createElement(Grid, { columns: 2, stackable: true },
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: 16 },
                            React.createElement(FieldWithErrorDisplay, { errors: _this.state.errors, errorPath: "/organization", labelContent: "Organization name", required: true },
                                React.createElement("div", { className: "organization-lookup-field" },
                                    React.createElement(Input, { icon: "building", loading: _this.state.organizationSearchLoading, placeholder: "California Institute of Technology", value: _this.state.organizationName, onChange: _this.onOrganizationNameChange, onBlur: _this.onOrganizationNameBlur }),
                                    _this.state.organizationSuggestionsOpen && _this.state.organizationSuggestions.length > 0 &&
                                        React.createElement("div", { className: "organization-suggestions" }, _this.state.organizationSuggestions.map(function (organization) { return (React.createElement("div", { key: organization.id, className: "organization-suggestion", onMouseDown: _this.onSelectOrganization(organization) },
                                            React.createElement("div", { className: "organization-suggestion-name" }, organization.name),
                                            React.createElement("div", { className: "organization-suggestion-description" }, rorDescription(organization)))); }))),
                                _this.state.organizationMatched &&
                                    React.createElement("p", { className: "organization-match-message" }, "\u2713 Organization matched.")))),
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, null,
                            React.createElement(FieldWithErrorDisplay, { errors: _this.state.errors, errorPath: "/category", labelContent: "Organization type", required: true },
                                React.createElement(Select, { placeholder: "Select...", options: ORGANIZATION_TYPE_OPTIONS, value: _this.state.organizationType, onChange: _this.onSelectFieldChange("organizationType") }))),
                        React.createElement(Grid.Column, null,
                            React.createElement(FieldWithErrorDisplay, { errors: _this.state.errors, errorPath: "/researchGroup", labelContent: "Lab, department, or team (optional)" },
                                React.createElement(Input, { placeholder: "Gates and Crellin Laboratories", value: _this.state.labTeam, onChange: _this.onFieldChange("labTeam") }))))),
                React.createElement(Header, { as: "h4", className: "new-registration-section-title" }, "Where should we ship your orders?"),
                React.createElement(Grid, { columns: 2, stackable: true },
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: 8 },
                            React.createElement(FieldWithErrorDisplay, { errors: _this.state.errors, errorPath: "/shippingAddress/countryCode", labelContent: "Delivery country", required: true },
                                React.createElement(Select, { search: true, placeholder: "Select...", options: COUNTRY_OPTIONS, value: _this.state.shippingAddress.countryCode, onChange: _this.onShippingCountryChange })))),
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: 16 },
                            React.createElement(FieldWithErrorDisplay, { errors: _this.state.errors, errorPath: "/shippingAddress/street", labelContent: "Street address", required: true },
                                React.createElement("div", { className: "address-lookup-field" },
                                    React.createElement(Input, { disabled: _this.state.shippingAddress.countryCode === "", icon: _this.state.shippingAddressSearchEnabled ? "search" : undefined, loading: _this.state.addressSearchLoading, value: _this.state.shippingAddress.street, onChange: _this.onShippingStreetChange, onBlur: _this.onShippingStreetBlur }),
                                    _this.state.shippingAddressSearchEnabled
                                        && _this.state.addressSuggestionsOpen
                                        && _this.state.addressSuggestions.length > 0 &&
                                        React.createElement("div", { className: "address-suggestions" }, _this.state.addressSuggestions.map(function (candidate, index) { return (React.createElement("div", { key: candidate.street + "-" + index, className: "address-suggestion", onMouseDown: _this.onSelectAddressCandidate(candidate) },
                                            React.createElement("div", { className: "address-suggestion-street" }, addressCandidateStreetLine(candidate)),
                                            React.createElement("div", { className: "address-suggestion-description" }, addressCandidateDescription(candidate)))); }))),
                                React.createElement("p", { className: "new-registration-address-hint" }, _this.state.shippingAddressSearchEnabled
                                    ? "Start typing to find and confirm the address."
                                    : "Use the address that should appear on shipping labels."),
                                React.createElement("div", { className: "new-registration-address-actions" }, _this.state.shippingAddressSearchEnabled
                                    ? React.createElement("button", { type: "button", className: "new-registration-link-button", onClick: _this.onEnterAddressManually }, "Enter address manually")
                                    : React.createElement("button", { type: "button", className: "new-registration-link-button", onClick: _this.onSearchForAddress }, "Search for an address"))))),
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: 8 },
                            React.createElement(FieldWithErrorDisplay, { errors: _this.state.errors, errorPath: "/shippingAddress/streetLine2", labelContent: "Building, room, or receiving details" },
                                React.createElement(Input, { disabled: _this.state.shippingAddress.countryCode === "", value: _this.state.shippingAddress.streetLine2, onChange: _this.onAddressFieldChange("shippingAddress", "streetLine2") })))),
                    React.createElement(Grid.Row, { columns: 3 },
                        React.createElement(Grid.Column, null,
                            React.createElement(FieldWithErrorDisplay, { errors: _this.state.errors, errorPath: "/shippingAddress/city", labelContent: "City / town", required: true },
                                React.createElement(Input, { disabled: _this.state.shippingAddress.countryCode === "", value: _this.state.shippingAddress.city, onChange: _this.onAddressFieldChange("shippingAddress", "city") }))),
                        React.createElement(Grid.Column, null,
                            React.createElement(FieldWithErrorDisplay, { errors: _this.state.errors, errorPath: "/shippingAddress/stateProvince", labelContent: "State / province / region", required: isUs }, isUs
                                ? React.createElement(Select, { search: true, placeholder: "Select...", options: US_STATE_OPTIONS, value: _this.state.shippingAddress.stateProvince, onChange: _this.onAddressSelectChange("shippingAddress", "stateProvince") })
                                : React.createElement(Input, { disabled: _this.state.shippingAddress.countryCode === "", value: _this.state.shippingAddress.stateProvince, onChange: _this.onAddressFieldChange("shippingAddress", "stateProvince") }))),
                        React.createElement(Grid.Column, null,
                            React.createElement(FieldWithErrorDisplay, { errors: _this.state.errors, errorPath: "/shippingAddress/zipPostalCode", labelContent: "Postal code", required: true },
                                React.createElement(Input, { disabled: _this.state.shippingAddress.countryCode === "", value: _this.state.shippingAddress.zipPostalCode, onChange: _this.onAddressFieldChange("shippingAddress", "zipPostalCode") })))),
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: 8 },
                            React.createElement(FieldWithErrorDisplay, { errors: _this.state.errors, errorPath: "/phone", labelContent: "Delivery phone", required: true },
                                React.createElement(Input, { type: "tel", placeholder: phoneInfoFor(_this.state.shippingAddress.countryCode).example || "+1 (201) 555-0123", value: _this.state.deliveryPhone, onChange: _this.onPhoneFieldChange("deliveryPhone", _this.state.shippingAddress.countryCode) })),
                            React.createElement("p", { className: "new-registration-hint" }, "Only used if the carrier has a delivery issue."))),
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: 8 },
                            React.createElement(FieldWithErrorDisplay, { errors: _this.state.errors, errorPath: "/courierAccountType", labelContent: "Courier account" },
                                React.createElement(Select, { options: COURIER_ACCOUNT_OPTIONS, value: _this.state.courierAccountType, onChange: _this.onCourierAccountTypeChange }))),
                        _this.state.courierAccountType !== "NONE" &&
                            React.createElement(Grid.Column, { width: 8 },
                                React.createElement(FieldWithErrorDisplay, { errors: _this.state.errors, errorPath: "/courierAccountNumber", labelContent: courierAccountLabel, required: true },
                                    React.createElement(Input, { placeholder: "Account number", value: _this.state.courierAccountNumber, onChange: _this.onFieldChange("courierAccountNumber") }))))),
                React.createElement(ErrorDisplay, { errors: _this.state.errors, errorPath: "/" }));
        };
        _this.renderBillingDetailsStep = function () {
            var isUs = _this.state.billingAddress.countryCode === "US";
            return React.createElement(Form, { error: _this.state.errors.length > 0 },
                React.createElement("div", { className: "billing-details-section" },
                    React.createElement("div", { className: "billing-details-heading-row" },
                        React.createElement(Header, { as: "h4", className: "new-registration-section-title" }, "Billing address")),
                    _this.state.useShippingForBilling
                        ? React.createElement(React.Fragment, null,
                            _this.renderAddressSummary(_this.state.shippingAddress),
                            React.createElement("button", { type: "button", className: "new-registration-link-button", onClick: _this.onUseDifferentBillingAddress }, "Use a different billing address"))
                        : React.createElement(React.Fragment, null,
                            React.createElement("div", { className: "billing-details-edit-block" },
                                React.createElement(Grid, { columns: 2, stackable: true },
                                    React.createElement(Grid.Row, null,
                                        React.createElement(Grid.Column, { width: 8 },
                                            React.createElement(FieldWithErrorDisplay, { errors: _this.state.errors, errorPath: "/billingAddress/countryCode", labelContent: "Country", required: true },
                                                React.createElement(Select, { search: true, placeholder: "Select...", options: COUNTRY_OPTIONS, value: _this.state.billingAddress.countryCode, onChange: _this.onBillingCountryChange })))),
                                    React.createElement(Grid.Row, null,
                                        React.createElement(Grid.Column, { width: 16 },
                                            React.createElement(FieldWithErrorDisplay, { errors: _this.state.errors, errorPath: "/billingAddress/street", labelContent: "Street address", required: true },
                                                React.createElement("div", { className: "address-lookup-field" },
                                                    React.createElement(Input, { disabled: _this.state.billingAddress.countryCode === "", icon: _this.state.billingAddressSearchEnabled ? "search" : undefined, loading: _this.state.billingAddressSearchLoading, value: _this.state.billingAddress.street, onChange: _this.onBillingStreetChange, onBlur: _this.onBillingStreetBlur }),
                                                    _this.state.billingAddressSearchEnabled
                                                        && _this.state.billingAddressSuggestionsOpen
                                                        && _this.state.billingAddressSuggestions.length > 0 &&
                                                        React.createElement("div", { className: "address-suggestions" }, _this.state.billingAddressSuggestions.map(function (candidate, index) { return (React.createElement("div", { key: candidate.street + "-" + index, className: "address-suggestion", onMouseDown: _this.onSelectBillingAddressCandidate(candidate) },
                                                            React.createElement("div", { className: "address-suggestion-street" }, addressCandidateStreetLine(candidate)),
                                                            React.createElement("div", { className: "address-suggestion-description" }, addressCandidateDescription(candidate)))); }))),
                                                React.createElement("div", { className: "new-registration-address-actions" }, _this.state.billingAddressSearchEnabled
                                                    ? React.createElement("button", { type: "button", className: "new-registration-link-button", onClick: _this.onEnterBillingAddressManually }, "Enter address manually")
                                                    : React.createElement("button", { type: "button", className: "new-registration-link-button", onClick: _this.onSearchForBillingAddress }, "Search for an address"))))),
                                    React.createElement(Grid.Row, null,
                                        React.createElement(Grid.Column, { width: 8 },
                                            React.createElement(FieldWithErrorDisplay, { errors: _this.state.errors, errorPath: "/billingAddress/streetLine2", labelContent: "Apartment, suite, or building" },
                                                React.createElement(Input, { disabled: _this.state.billingAddress.countryCode === "", value: _this.state.billingAddress.streetLine2, onChange: _this.onAddressFieldChange("billingAddress", "streetLine2") })))),
                                    React.createElement(Grid.Row, { columns: 3 },
                                        React.createElement(Grid.Column, null,
                                            React.createElement(FieldWithErrorDisplay, { errors: _this.state.errors, errorPath: "/billingAddress/city", labelContent: "City", required: true },
                                                React.createElement(Input, { disabled: _this.state.billingAddress.countryCode === "", value: _this.state.billingAddress.city, onChange: _this.onAddressFieldChange("billingAddress", "city") }))),
                                        React.createElement(Grid.Column, null,
                                            React.createElement(FieldWithErrorDisplay, { errors: _this.state.errors, errorPath: "/billingAddress/stateProvince", labelContent: "State", required: isUs }, isUs
                                                ? React.createElement(Select, { search: true, placeholder: "Select...", options: US_STATE_OPTIONS, value: _this.state.billingAddress.stateProvince, onChange: _this.onAddressSelectChange("billingAddress", "stateProvince") })
                                                : React.createElement(Input, { disabled: _this.state.billingAddress.countryCode === "", value: _this.state.billingAddress.stateProvince, onChange: _this.onAddressFieldChange("billingAddress", "stateProvince") }))),
                                        React.createElement(Grid.Column, null,
                                            React.createElement(FieldWithErrorDisplay, { errors: _this.state.errors, errorPath: "/billingAddress/zipPostalCode", labelContent: "ZIP code", required: true },
                                                React.createElement(Input, { disabled: _this.state.billingAddress.countryCode === "", value: _this.state.billingAddress.zipPostalCode, onChange: _this.onAddressFieldChange("billingAddress", "zipPostalCode") })))))),
                            React.createElement("button", { type: "button", className: "new-registration-link-button", onClick: _this.onUseShippingBillingAddress }, "Use shipping address instead"))),
                React.createElement("div", { className: "billing-details-divider" }),
                React.createElement("div", { className: "billing-details-section" },
                    React.createElement("div", { className: "billing-details-heading-row" },
                        React.createElement(Header, { as: "h4", className: "new-registration-section-title" }, "Invoice contact")),
                    _this.state.useContactForBilling
                        ? React.createElement(React.Fragment, null,
                            React.createElement("div", { className: "billing-details-summary billing-contact-summary" },
                                React.createElement("div", { className: "billing-contact-row" },
                                    React.createElement("span", { className: "billing-contact-label" }, "Email"),
                                    React.createElement("span", null, _this.state.email)),
                                React.createElement("div", { className: "billing-contact-row" },
                                    React.createElement("span", { className: "billing-contact-label" }, "Phone"),
                                    React.createElement("span", null, _this.state.deliveryPhone))),
                            React.createElement("button", { type: "button", className: "new-registration-link-button", onClick: _this.onUseDifferentBillingContact }, "Use a different billing contact"))
                        : React.createElement(React.Fragment, null,
                            React.createElement("div", { className: "billing-details-edit-block" },
                                React.createElement(Grid, { columns: 2, stackable: true },
                                    React.createElement(Grid.Row, null,
                                        React.createElement(Grid.Column, null,
                                            React.createElement(FieldWithErrorDisplay, { errors: _this.state.errors, errorPath: "/billingEmail", labelContent: "Invoice email address", required: true },
                                                React.createElement(Input, { type: "email", placeholder: "invoices@example.org", value: _this.state.invoiceEmail, onChange: _this.onFieldChange("invoiceEmail") }))),
                                        React.createElement(Grid.Column, null,
                                            React.createElement(FieldWithErrorDisplay, { errors: _this.state.errors, errorPath: "/billingPhone", labelContent: "Billing phone", required: true },
                                                React.createElement(Input, { type: "tel", placeholder: phoneInfoFor(_this.billingCountryCode()).example || "+1 (201) 555-0123", value: _this.state.billingPhone, onChange: _this.onPhoneFieldChange("billingPhone", _this.billingCountryCode()) })),
                                            React.createElement("p", { className: "new-registration-hint" }, "Used if we need to clarify an invoice."))))),
                            React.createElement("button", { type: "button", className: "new-registration-link-button", onClick: _this.onUseAccountBillingContact }, "Use account email and receiving contact phone instead"))),
                React.createElement(ErrorDisplay, { errors: _this.state.errors, errorPath: "/" }));
        };
        _this.renderTermsPrivacyStep = function () {
            return React.createElement(Form, { error: _this.state.errors.length > 0 },
                React.createElement(Header, { as: "h4", className: "new-registration-section-title" }, "Custom probes and your privacy"),
                React.createElement(List, { bulleted: true, className: "new-registration-privacy-list" },
                    React.createElement(List.Item, null,
                        React.createElement("strong", null, "Custom design without a catalog listing."),
                        " Through our Infinite Catalog, every HCR\u2122 HiFi Probe is custom-designed with no design fee. Previously ordered probes are not published for browsing."),
                    React.createElement(List.Item, null,
                        React.createElement("strong", null, "Your identity stays separate."),
                        " We won\u2019t associate your identity with a product or sequence information, or share it with another customer, without written permission."),
                    React.createElement(List.Item, null,
                        React.createElement("strong", null, "Your personal information is protected."),
                        " We encrypt it, restrict access to authorized personnel, and do not sell or trade it.")),
                React.createElement("p", null,
                    "See our",
                    " ",
                    React.createElement("a", { href: PRIVACY_POLICY_URL, target: "_blank", rel: "noreferrer" }, "Privacy Policy"),
                    " ",
                    "for details."),
                React.createElement(Divider, null),
                React.createElement(FieldWithErrorDisplay, { errors: _this.state.errors, errorPath: "/legal/terms", labelContent: "" },
                    React.createElement(Checkbox, { label: {
                            children: React.createElement(React.Fragment, null,
                                "I agree to the",
                                " ",
                                React.createElement("a", { href: TERMS_URL, target: "_blank", rel: "noreferrer" }, "Terms"))
                        }, checked: _this.state.agreeTerms, onChange: _this.onCheckboxFieldChange("agreeTerms") })),
                React.createElement(ErrorDisplay, { errors: _this.state.errors, errorPath: "/" }));
        };
        _this.toggleShowPassword = function () {
            _this.setState(function (prev) { return ({ showPassword: !prev.showPassword }); });
        };
        _this.toggleShowConfirmPassword = function () {
            _this.setState(function (prev) { return ({ showConfirmPassword: !prev.showConfirmPassword }); });
        };
        _this.onFieldChange = function (key) {
            return function (_, data) {
                var _a;
                _this.setState((_a = {}, _a[key] = data.value, _a));
            };
        };
        _this.onPasswordChange = function (_, data) {
            var password = data.value;
            if (password === "") {
                _this.setState({ password: password, passwordScore: 0 });
                return;
            }
            var userInputs = [_this.state.firstName, _this.state.lastName, _this.state.email].filter(function (s) { return s !== ""; });
            var result = zxcvbn(password, userInputs);
            _this.setState({ password: password, passwordScore: result.score });
        };
        _this.onSelectFieldChange = function (key) {
            return function (_, data) {
                var _a;
                var val = data.value;
                if (typeof val !== "string") {
                    throw new Error("Unexpected value for " + key + ": " + val);
                }
                _this.setState((_a = {}, _a[key] = val, _a));
            };
        };
        _this.onCourierAccountTypeChange = function (_, data) {
            var val = data.value;
            if (val !== "NONE" && val !== "FEDEX" && val !== "DHL") {
                throw new Error("Unexpected value for courierAccountType: " + val);
            }
            _this.setState(function (prev) { return ({
                courierAccountType: val,
                courierAccountNumber: val === "NONE" ? "" : prev.courierAccountNumber,
            }); });
        };
        _this.onCheckboxFieldChange = function (key) {
            return function (_, data) {
                var _a;
                _this.setState((_a = {}, _a[key] = data.checked === true, _a));
            };
        };
        _this.onAddressFieldChange = function (addressKey, field) {
            return function (_, data) {
                _this.setState(function (prev) {
                    var _a, _b;
                    return (_a = {},
                        _a[addressKey] = __assign(__assign({}, prev[addressKey]), (_b = {}, _b[field] = data.value, _b)),
                        _a);
                });
            };
        };
        _this.onAddressSelectChange = function (addressKey, field) {
            return function (_, data) {
                var val = data.value;
                if (typeof val !== "string") {
                    throw new Error("Unexpected value for " + addressKey + "." + field + ": " + val);
                }
                _this.setState(function (prev) {
                    var _a, _b;
                    return (_a = {},
                        _a[addressKey] = __assign(__assign({}, prev[addressKey]), (_b = {}, _b[field] = val, _b)),
                        _a);
                });
            };
        };
        _this.onOrganizationNameChange = function (event, data) {
            _this.setState({ organizationName: data.value, organizationSuggestionsOpen: true, organizationMatched: false });
            _this.debouncedOrganizationSearch(event, data.value);
        };
        _this.runOrganizationSearch = function (query) {
            if (_this.organizationSearchAbortController) {
                _this.organizationSearchAbortController.abort();
            }
            var controller = new AbortController();
            _this.organizationSearchAbortController = controller;
            var preferredCountry = _this.state.shippingAddress.countryCode || browserLocaleCountryCode();
            _this.setState({ organizationSearchLoading: true });
            searchRorOrganizations(query, controller.signal, preferredCountry)
                .then(function (organizations) {
                if (!controller.signal.aborted) {
                    _this.setState({ organizationSuggestions: organizations, organizationSearchLoading: false });
                }
            })
                .catch(function () {
                // Ignore failed/aborted lookups; the organization name remains usable as free text
                if (!controller.signal.aborted) {
                    _this.setState({ organizationSearchLoading: false });
                }
            });
        };
        _this.onOrganizationNameBlur = function () {
            window.setTimeout(function () { return _this.setState({ organizationSuggestionsOpen: false }); }, 150);
        };
        _this.onSelectOrganization = function (organization) { return function () {
            if (_this.organizationSearchAbortController) {
                _this.organizationSearchAbortController.abort();
            }
            _this.setState(function (prev) { return ({
                organizationName: organization.name,
                organizationType: categoryForRorTypes(organization.types) || prev.organizationType,
                shippingAddress: organization.countryCode
                    ? __assign(__assign({}, prev.shippingAddress), { countryCode: organization.countryCode }) : prev.shippingAddress,
                organizationSuggestions: [],
                organizationSuggestionsOpen: false,
                organizationSearchLoading: false,
                organizationMatched: true,
            }); });
        }; };
        // A country change invalidates any in-progress address lookup: suggestions and a group entryId
        // from one country's autocomplete are meaningless once the query would run against a different one.
        _this.onShippingCountryChange = function (_, data) {
            var val = data.value;
            if (typeof val !== "string") {
                throw new Error("Unexpected value for shippingAddress.countryCode: " + val);
            }
            _this.addressSearchSequence += 1;
            _this.setState(function (prev) { return ({
                shippingAddress: __assign(__assign({}, prev.shippingAddress), { countryCode: val }),
                addressSuggestions: [],
                addressSuggestionsOpen: false,
                addressSearchLoading: false,
                selectedGroupEntryId: null,
            }); });
        };
        _this.onShippingStreetChange = function (event, data) {
            if (!_this.state.shippingAddressSearchEnabled) {
                _this.setState(function (prev) { return ({
                    shippingAddress: __assign(__assign({}, prev.shippingAddress), { street: data.value }),
                    addressSuggestions: [],
                    addressSuggestionsOpen: false,
                    addressSearchLoading: false,
                    selectedGroupEntryId: null,
                }); });
                return;
            }
            _this.setState(function (prev) { return ({
                shippingAddress: __assign(__assign({}, prev.shippingAddress), { street: data.value }),
                addressSuggestionsOpen: true,
            }); });
            _this.debouncedAddressSearch(event, data.value);
        };
        _this.runAddressSearch = function (query, selected) {
            if (selected === void 0) { selected = _this.state.selectedGroupEntryId; }
            var country = _this.state.shippingAddress.countryCode;
            if (!_this.state.shippingAddressSearchEnabled || query.trim().length < 3 || country === "") {
                _this.setState({ addressSuggestions: [], addressSearchLoading: false, selectedGroupEntryId: null });
                return;
            }
            var sequence = ++_this.addressSearchSequence;
            _this.setState({ addressSearchLoading: true });
            lookupAddress(query, country, selected || undefined)
                .then(function (candidates) {
                if (sequence === _this.addressSearchSequence) {
                    _this.setState({ addressSuggestions: candidates, addressSearchLoading: false });
                }
            })
                .catch(function () {
                // Ignore failed lookups; the street address remains usable as free text
                if (sequence === _this.addressSearchSequence) {
                    _this.setState({ addressSearchLoading: false });
                }
            });
        };
        _this.onShippingStreetBlur = function () {
            window.setTimeout(function () { return _this.setState({ addressSuggestionsOpen: false }); }, 150);
        };
        // Groups of secondaries (e.g. apartment units) are returned collapsed, with `entries` > 0 and no
        // usable street/city/zip yet. Selecting one re-queries with `selected: entryId` to expand it into
        // its individual secondary suggestions instead of treating it as a final, fillable address.
        //
        // preventDefault on mousedown stops the Input from blurring when a suggestion is clicked. Without
        // it, onShippingStreetBlur's 150ms close-timer fires before the re-query above resolves and forces
        // addressSuggestionsOpen back to false, so the fetched unit options render into a closed dropdown.
        _this.onSelectAddressCandidate = function (candidate) { return function (event) {
            event.preventDefault();
            if (candidate.entries > 0 && candidate.entryId) {
                var street = addressCandidateStreetLine(candidate);
                _this.setState({
                    shippingAddress: __assign(__assign({}, _this.state.shippingAddress), { street: street }),
                    selectedGroupEntryId: candidate.entryId,
                    addressSuggestionsOpen: true,
                });
                _this.runAddressSearch(street, candidate.entryId);
                return;
            }
            _this.addressSearchSequence += 1;
            _this.setState(function (prev) { return ({
                shippingAddress: __assign(__assign({}, prev.shippingAddress), { street: candidate.street, streetLine2: candidate.secondary || prev.shippingAddress.streetLine2, city: candidate.city, stateProvince: candidate.state || prev.shippingAddress.stateProvince, zipPostalCode: candidate.zipCode }),
                addressSuggestions: [],
                addressSuggestionsOpen: false,
                addressSearchLoading: false,
                selectedGroupEntryId: null,
            }); });
        }; };
        _this.onEnterAddressManually = function () {
            _this.addressSearchSequence += 1;
            _this.setState({
                shippingAddressSearchEnabled: false,
                addressSuggestions: [],
                addressSuggestionsOpen: false,
                addressSearchLoading: false,
                selectedGroupEntryId: null,
            });
        };
        _this.onSearchForAddress = function () {
            _this.setState({ shippingAddressSearchEnabled: true, addressSuggestionsOpen: true }, function () {
                _this.runAddressSearch(_this.state.shippingAddress.street);
            });
        };
        _this.onUseDifferentBillingAddress = function () {
            _this.billingAddressSearchSequence += 1;
            _this.setState(function (prev) { return ({
                useShippingForBilling: false,
                billingAddress: _this.isEmptyAddress(prev.billingAddress) ? __assign({}, prev.shippingAddress) : prev.billingAddress,
                billingAddressSuggestions: [],
                billingAddressSuggestionsOpen: false,
                billingAddressSearchLoading: false,
                selectedBillingGroupEntryId: null,
            }); });
        };
        _this.onUseShippingBillingAddress = function () {
            _this.billingAddressSearchSequence += 1;
            _this.setState({
                useShippingForBilling: true,
                billingAddressSuggestions: [],
                billingAddressSuggestionsOpen: false,
                billingAddressSearchLoading: false,
                selectedBillingGroupEntryId: null,
                errors: _this.state.errors.filter(function (error) { return !error.path.startsWith("/billingAddress"); }),
            });
        };
        _this.onUseDifferentBillingContact = function () {
            _this.setState({ useContactForBilling: false });
        };
        _this.onUseAccountBillingContact = function () {
            _this.setState({
                useContactForBilling: true,
                errors: _this.state.errors.filter(function (error) {
                    return error.path !== "/billingEmail" && error.path !== "/billingPhone";
                }),
            });
        };
        _this.onBillingCountryChange = function (_, data) {
            var val = data.value;
            if (typeof val !== "string") {
                throw new Error("Unexpected value for billingAddress.countryCode: " + val);
            }
            _this.billingAddressSearchSequence += 1;
            _this.setState(function (prev) { return ({
                billingAddress: __assign(__assign({}, prev.billingAddress), { countryCode: val }),
                billingAddressSuggestions: [],
                billingAddressSuggestionsOpen: false,
                billingAddressSearchLoading: false,
                selectedBillingGroupEntryId: null,
            }); });
        };
        _this.onBillingStreetChange = function (event, data) {
            if (!_this.state.billingAddressSearchEnabled) {
                _this.setState(function (prev) { return ({
                    billingAddress: __assign(__assign({}, prev.billingAddress), { street: data.value }),
                    billingAddressSuggestions: [],
                    billingAddressSuggestionsOpen: false,
                    billingAddressSearchLoading: false,
                    selectedBillingGroupEntryId: null,
                }); });
                return;
            }
            _this.setState(function (prev) { return ({
                billingAddress: __assign(__assign({}, prev.billingAddress), { street: data.value }),
                billingAddressSuggestionsOpen: true,
            }); });
            _this.debouncedBillingAddressSearch(event, data.value);
        };
        _this.runBillingAddressSearch = function (query, selected) {
            if (selected === void 0) { selected = _this.state.selectedBillingGroupEntryId; }
            var country = _this.state.billingAddress.countryCode;
            if (!_this.state.billingAddressSearchEnabled || query.trim().length < 3 || country === "") {
                _this.setState({
                    billingAddressSuggestions: [],
                    billingAddressSearchLoading: false,
                    selectedBillingGroupEntryId: null,
                });
                return;
            }
            var sequence = ++_this.billingAddressSearchSequence;
            _this.setState({ billingAddressSearchLoading: true });
            lookupAddress(query, country, selected || undefined)
                .then(function (candidates) {
                if (sequence === _this.billingAddressSearchSequence) {
                    _this.setState({ billingAddressSuggestions: candidates, billingAddressSearchLoading: false });
                }
            })
                .catch(function () {
                // Ignore failed lookups; the billing address remains usable as free text
                if (sequence === _this.billingAddressSearchSequence) {
                    _this.setState({ billingAddressSearchLoading: false });
                }
            });
        };
        _this.onBillingStreetBlur = function () {
            window.setTimeout(function () { return _this.setState({ billingAddressSuggestionsOpen: false }); }, 150);
        };
        _this.onSelectBillingAddressCandidate = function (candidate) { return function (event) {
            event.preventDefault();
            if (candidate.entries > 0 && candidate.entryId) {
                var street = addressCandidateStreetLine(candidate);
                _this.setState({
                    billingAddress: __assign(__assign({}, _this.state.billingAddress), { street: street }),
                    selectedBillingGroupEntryId: candidate.entryId,
                    billingAddressSuggestionsOpen: true,
                });
                _this.runBillingAddressSearch(street, candidate.entryId);
                return;
            }
            _this.billingAddressSearchSequence += 1;
            _this.setState(function (prev) { return ({
                billingAddress: __assign(__assign({}, prev.billingAddress), { street: candidate.street, streetLine2: candidate.secondary || prev.billingAddress.streetLine2, city: candidate.city, stateProvince: candidate.state || prev.billingAddress.stateProvince, zipPostalCode: candidate.zipCode }),
                billingAddressSuggestions: [],
                billingAddressSuggestionsOpen: false,
                billingAddressSearchLoading: false,
                selectedBillingGroupEntryId: null,
            }); });
        }; };
        _this.onEnterBillingAddressManually = function () {
            _this.billingAddressSearchSequence += 1;
            _this.setState({
                billingAddressSearchEnabled: false,
                billingAddressSuggestions: [],
                billingAddressSuggestionsOpen: false,
                billingAddressSearchLoading: false,
                selectedBillingGroupEntryId: null,
            });
        };
        _this.onSearchForBillingAddress = function () {
            _this.setState({ billingAddressSearchEnabled: true, billingAddressSuggestionsOpen: true }, function () {
                _this.runBillingAddressSearch(_this.state.billingAddress.street);
            });
        };
        _this.billingCountryCode = function () {
            return _this.state.useShippingForBilling ? _this.state.shippingAddress.countryCode : _this.state.billingAddress.countryCode;
        };
        _this.onPhoneFieldChange = function (key, countryCode) {
            return function (_, data) {
                var _a;
                _this.setState((_a = {},
                    _a[key] = formatPhoneNumberInput(data.value, countryCode),
                    _a));
            };
        };
        _this.onBack = function () {
            if (_this.state.loading) {
                return;
            }
            _this.setState(function (prev) { return ({ step: Math.max(1, prev.step - 1), errors: [] }); });
        };
        _this.onStepIndicatorClick = function (step) { return function () {
            if (step < _this.state.step && !_this.state.accountCreated && !_this.state.loading) {
                _this.setState({ step: step, errors: [] });
            }
        }; };
        _this.onContinueFromStep = function (step) { return function () { return __awaiter(_this, void 0, void 0, function () {
            var resp, body, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState({ loading: true, errors: [] });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 6]);
                        return [4 /*yield*/, postJsonWithAuthn(VALIDATE_ENDPOINT, JSON.stringify(this.buildStepValidatePayload(step)))];
                    case 2:
                        resp = _a.sent();
                        if (resp.ok) {
                            this.setState({ step: step + 1, errors: [], loading: false });
                            return [2 /*return*/];
                        }
                        if (!(resp.status === 400)) return [3 /*break*/, 4];
                        return [4 /*yield*/, resp.json()];
                    case 3:
                        body = _a.sent();
                        this.setState({ errors: body.errors, loading: false });
                        return [2 /*return*/];
                    case 4:
                        this.setState({ loading: false, errors: [{ path: "/", msg: "An unexpected error occurred" }] });
                        return [3 /*break*/, 6];
                    case 5:
                        e_1 = _a.sent();
                        console.error("Couldn't validate registration step " + step + ": " + e_1);
                        this.setState({ loading: false, errors: [{ path: "/", msg: "An unexpected error occurred" }] });
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        }); }; };
        _this.buildStepValidatePayload = function (step) { return (__assign(__assign({}, _this.buildRegisterRequestBody()), { step: step, courierAccountType: _this.state.courierAccountType, courierAccountNumber: _this.state.courierAccountType === "NONE"
                ? ""
                : _this.state.courierAccountNumber.trim() })); };
        _this.firstStepForRegistrationErrors = function (errors) {
            if (errors.some(function (error) { return [
                "/firstName",
                "/lastName",
                "/email",
                "/password",
                "/confirmPassword",
            ].indexOf(error.path) >= 0; })) {
                return 1;
            }
            if (errors.some(function (error) {
                return error.path === "/organization"
                    || error.path === "/category"
                    || error.path === "/phone"
                    || error.path === "/courierAccountNumber"
                    || error.path.startsWith("/shippingAddress");
            })) {
                return 2;
            }
            if (errors.some(function (error) {
                return error.path === "/billingEmail"
                    || error.path === "/billingPhone"
                    || error.path.startsWith("/billingAddress");
            })) {
                return 3;
            }
            return 4;
        };
        _this.normalizedAddress = function (address) { return ({
            street: normalizeShippingLabelText(address.street),
            streetLine2: normalizeShippingLabelText(address.streetLine2),
            city: normalizeShippingLabelText(address.city),
            stateProvince: normalizeShippingLabelText(address.stateProvince),
            zipPostalCode: normalizeShippingLabelText(address.zipPostalCode),
            countryCode: address.countryCode,
        }); };
        _this.renderAddressSummary = function (address) {
            var localityLine = _this.addressLocalityLine(address);
            return React.createElement("div", { className: "billing-details-summary" },
                address.street.trim() !== "" && React.createElement("div", null, address.street),
                address.streetLine2.trim() !== "" && React.createElement("div", null, address.streetLine2),
                localityLine !== "" && React.createElement("div", null, localityLine),
                address.countryCode !== "" && React.createElement("div", null, _this.countryText(address.countryCode)));
        };
        _this.addressLocalityLine = function (address) {
            return [address.city, address.stateProvince, address.zipPostalCode]
                .filter(function (part) { return part.trim() !== ""; })
                .join(", ");
        };
        _this.countryText = function (code) {
            var match = COUNTRY_OPTIONS.find(function (c) { return c.value === code; });
            return match !== undefined && typeof match.text === "string" ? match.text : code;
        };
        _this.isEmptyAddress = function (address) {
            return address.street.trim() === ""
                && address.streetLine2.trim() === ""
                && address.city.trim() === ""
                && address.stateProvince.trim() === ""
                && address.zipPostalCode.trim() === ""
                && address.countryCode === "";
        };
        _this.buildRegisterRequestBody = function () {
            var shippingAddress = _this.normalizedAddress(_this.state.shippingAddress);
            var billingAddress = _this.state.useShippingForBilling
                ? shippingAddress
                : _this.normalizedAddress(_this.state.billingAddress);
            var billingEmail = _this.state.useContactForBilling ? _this.state.email.trim() : _this.state.invoiceEmail.trim();
            var billingPhone = _this.state.useContactForBilling ? _this.state.deliveryPhone : _this.state.billingPhone;
            return {
                firstName: normalizeShippingLabelText(_this.state.firstName),
                lastName: normalizeShippingLabelText(_this.state.lastName),
                referredBy: "",
                email: _this.state.email.trim(),
                password: _this.state.password,
                passwordConfirmation: _this.state.confirmPassword,
                phone: _this.state.deliveryPhone,
                organization: normalizeShippingLabelText(_this.state.organizationName),
                researchGroup: normalizeShippingLabelText(_this.state.labTeam),
                category: _this.state.organizationType,
                shippingAddress: shippingAddress,
                billingAddress: billingAddress,
                billingEmail: billingEmail,
                billingPhone: billingPhone,
                courierAccountNumber: _this.courierAccountNumberForRequest(),
                legal: { privacy: _this.state.agreeTerms, terms: _this.state.agreeTerms },
                referralId: null,
            };
        };
        _this.onSubmitRegistration = function () {
            if (!_this.state.agreeTerms) {
                _this.setState({ errors: [{ path: "/legal/terms", msg: "You must agree to the Terms to continue" }] });
                return;
            }
            _this.setState({ loading: true, errors: [] }, function () {
                postJsonWithAuthn(REGISTER_ENDPOINT, JSON.stringify(_this.buildRegisterRequestBody()))
                    .then(function (resp) {
                    if (resp.ok) {
                        _this.setState({
                            loading: false,
                            accountCreated: true,
                            step: EMAIL_VERIFICATION_STEP,
                            errors: [],
                        });
                        return;
                    }
                    else if (resp.status === 400) {
                        return resp.json();
                    }
                    else {
                        _this.setState({
                            loading: false,
                            errors: [{ path: "/", msg: "An unexpected error occurred" }],
                        });
                        return;
                    }
                })
                    .then(function (resp) {
                    if (resp !== undefined) {
                        _this.setState({
                            loading: false,
                            errors: resp.errors,
                            step: _this.firstStepForRegistrationErrors(resp.errors),
                        });
                    }
                })
                    .catch(function (rej) {
                    console.error("Couldn't submit registration: " + rej);
                    _this.setState({
                        loading: false,
                        errors: [{ path: "/", msg: "An unexpected error occurred" }],
                    });
                });
            });
        };
        _this.courierAccountName = function () {
            switch (_this.state.courierAccountType) {
                case "FEDEX":
                    return "FedEx";
                case "DHL":
                    return "DHL";
                case "NONE":
                    return "";
            }
        };
        _this.courierAccountNumberLabel = function () {
            var name = _this.courierAccountName();
            return name === "" ? "Account number" : name + " account number";
        };
        _this.courierAccountNumberForRequest = function () {
            if (_this.state.courierAccountType === "NONE") {
                return "";
            }
            return _this.courierAccountName() + ": " + _this.state.courierAccountNumber.trim();
        };
        _this.state = {
            step: 1,
            loading: false,
            accountCreated: false,
            errors: [],
            firstName: "",
            lastName: "",
            email: "",
            password: "",
            passwordScore: 0,
            confirmPassword: "",
            showPassword: false,
            showConfirmPassword: false,
            organizationName: "",
            organizationType: "",
            labTeam: "",
            shippingAddress: EMPTY_ADDRESS,
            deliveryPhone: "",
            courierAccountType: "NONE",
            courierAccountNumber: "",
            useShippingForBilling: true,
            useContactForBilling: true,
            billingAddress: EMPTY_ADDRESS,
            invoiceEmail: "",
            billingPhone: "",
            allowLabDiscussion: false,
            agreeTerms: false,
            organizationSuggestions: [],
            organizationSuggestionsOpen: false,
            organizationSearchLoading: false,
            organizationMatched: false,
            addressSuggestions: [],
            addressSuggestionsOpen: false,
            addressSearchLoading: false,
            selectedGroupEntryId: null,
            shippingAddressSearchEnabled: true,
            billingAddressSuggestions: [],
            billingAddressSuggestionsOpen: false,
            billingAddressSearchLoading: false,
            selectedBillingGroupEntryId: null,
            billingAddressSearchEnabled: true,
        };
        return _this;
    }
    NewRegistrationPage.prototype.render = function () {
        var rootClassNames = ["new-registration-page", "starter-kit-registration-flow"];
        if (ORIGIN === "hcr") {
            rootClassNames.push("hcr-registration-page");
        }
        var rootClassName = rootClassNames.join(" ");
        return React.createElement("div", { id: "non-header-portion", className: rootClassName },
            React.createElement(Header, { as: "h2", className: "new-registration-title" }, this.state.step === EMAIL_VERIFICATION_STEP ? "Check your email" : "Create your account"),
            this.renderStepIndicator(),
            React.createElement(Dimmer.Dimmable, { as: "div", className: "new-registration-panel" },
                React.createElement(Dimmer, { active: this.state.loading, inverted: true },
                    React.createElement(Loader, null)),
                this.renderStepBody()),
            this.renderActions());
    };
    return NewRegistrationPage;
}(React.PureComponent));
export default NewRegistrationPage;
//# sourceMappingURL=NewRegistrationPage.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/Registration/NewRegistrationPage.js
// module id = 1378
// module chunks = 0